let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fxn2i")).then(() => parcelRequire('aWxTt'));